/**
 * @file: 加载微应用
 * @returns: 返回微应用的实例
 */

 import { initGlobalState } from 'qiankun';
 import { FPageConfig, FRegisterConfig } from '../typings';
 import { register } from '../webMicroApp/industryPlatform';
 import store from '../store/index';

 export default async function(config: FRegisterConfig): Promise<{ update?: (value: any) => void }> {
   // 根据 PageID 进行各个平台进行分发
   const info: FPageConfig[] = store.getState().get('industryPlatform') as any;
   const pageInfo: FPageConfig = info.reduce((target: any, curr: FPageConfig) => {
     if (curr.appId === config.pageId) {
       target = curr;
     }
     return target;
   }, null);
   if (pageInfo.platform === 'industry') {
      // 进行权限验证
      const microAppStateActions = initGlobalState({});
     register({
       // 此处的路径需要从initial中获取
       entry: `${pageInfo.appUrl}${pageInfo.path}`,
       container: config.container,
       props: {
         baseApiUrl: pageInfo.apiBaseUrl,
         loginUrl: config?.props?.loginUrl,
         dispatch: (value: { type: string, data: any }) => { store.dispatch({ type: 'COMMIT_EVENT', payload: value }) },
         ...config.props,
       },
       activeRule: config.activeRule,
       loader: config.loader
     });
     return {
        update: (props: any) => {
          microAppStateActions.setGlobalState({
            baseApiUrl: pageInfo.apiBaseUrl,
            loginUrl: config?.props?.loginUrl,
            dispatch: (value: { type: string, data: any }) => { store.dispatch({ type: 'COMMIT_EVENT', payload: value }) },
            ...config.props,
            ...props
          });
       }
     };
   }
   return {};
 }
